import { render, staticRenderFns } from "./UploadTip.vue?vue&type=template&id=c8837f2c&scoped=true&"
import script from "./UploadTip.vue?vue&type=script&lang=js&"
export * from "./UploadTip.vue?vue&type=script&lang=js&"
import style0 from "./UploadTip.vue?vue&type=style&index=0&id=c8837f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8837f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8837f2c')) {
      api.createRecord('c8837f2c', component.options)
    } else {
      api.reload('c8837f2c', component.options)
    }
    module.hot.accept("./UploadTip.vue?vue&type=template&id=c8837f2c&scoped=true&", function () {
      api.rerender('c8837f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Buy/UploadTip.vue"
export default component.exports